module.exports = __webpack_public_path__ + "media/slide3/contractMediaSlide3Part3vs-6eca37e9.png";